import useUserOnlineStatusText from 'APP/main/hooks/userOnlineStatusText';
import { User } from 'STORE/Users/User/User';

interface IWorkspaceMemberWithCheckboxPresenter {
  userOnlineStatusText: string;
}

export const useWorkspaceMemberWithCheckboxPresenter = (
  user: User
): IWorkspaceMemberWithCheckboxPresenter => {
  const userOnlineStatusText = useUserOnlineStatusText({ user });

  return {
    userOnlineStatusText,
  };
};
